import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { AgreementModules } from '@partiu/api/dashboard/modules.ts';
import { useTheme } from '@partiu/ui/contexts/ThemeProvider.tsx';
import { useModules } from '../../contexts/ProductsProvider.tsx';

// Convênios que não devem ver o Gerenciador de Mídias, mesmo com o módulo ativo.
export const MEDIA_MANAGER_HIDDEN_AGREEMENTS = [725]; // 725: Ligga

/**
 * Bloqueia a rota quando o módulo correspondente não está ativo. Esconder o item
 * do menu não impede o acesso direto pela URL.
 *
 * `module` lê os produtos do convênio, que são a fonte de verdade. `agreementFlag`
 * existe para os poucos módulos que não têm chave equivalente no metadata do
 * produto Super App e por isso continuam vindo do agreement. Quando os dois são
 * informados, basta um estar ativo para liberar a rota.
 *
 * O ProductsProvider segura o render até o convênio e os produtos chegarem, então
 * aqui nunca observamos um estado intermediário — não há redirect indevido durante
 * o carregamento.
 */
export function RequireModule({
  module,
  agreementFlag,
  hiddenForAgreements,
  children,
}: {
  module?: keyof AgreementModules;
  agreementFlag?: string;
  hiddenForAgreements?: number[];
} & PropsWithChildren) {
  const modules = useModules();
  const { id, extraData } = useTheme();

  const hasProductModule = !!module && !!modules[module];
  const hasAgreementFlag = !!agreementFlag && !!extraData?.[agreementFlag];
  const isHiddenForAgreement = !!id && !!hiddenForAgreements?.includes(id);

  if ((!hasProductModule && !hasAgreementFlag) || isHiddenForAgreement) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
